import joi from 'joi';
import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { collection } from '../../../shared/collection.json.def';

const response = joi.object({
	results: joi.array().items(collection),
});

export const definition = makeDefinitionFor(
	'/collection.json?jobId={job_id}',
	{
		description: 'Get an array of collections in the supplied job ID',
		method: 'get',
		summary: 'Collection list',
		tags: ['Collection'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
			{
				$ref: '#/components/parameters/jobIdPath',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: response,
		},
		generateValidationError(),
	]
);
